var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_3261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9743 102.267C99.0638 101.626 103.481 96.1706 102.841 90.0812C102.2 83.9917 96.7445 79.5744 90.6551 80.2149C84.5656 80.8553 80.1483 86.311 80.7888 92.4004C81.4292 98.4899 86.8849 102.907 92.9743 102.267Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8703 106.905C54.9598 106.265 59.377 100.809 58.7366 94.7198C58.0961 88.6304 52.6405 84.2131 46.5511 84.8536C40.4616 85.494 36.0443 90.9496 36.6848 97.0391C37.3252 103.129 42.7809 107.546 48.8703 106.905Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.535 17.1853C103.066 16.7551 102.435 16.547 101.803 16.6139L22.4156 24.9633C21.1977 25.0912 20.3139 26.182 20.4418 27.4C20.4574 27.5482 20.4879 27.6946 20.5329 27.8369L33.9923 71.013C34.31 72.0178 35.291 72.6602 36.3389 72.5498C36.4365 72.546 36.5337 72.5358 36.63 72.5192L101.858 56.7405C102.838 56.5032 103.534 55.6349 103.553 54.6269L104.253 18.8798C104.27 18.2377 104.008 17.6196 103.535 17.1853Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2319 62.8016C43.1539 62.9146 42.1523 62.2315 41.8637 61.1868L34.6703 35.1883C34.3798 33.9986 35.1088 32.7988 36.2985 32.5084C37.4377 32.2301 38.5966 32.8872 38.9429 34.0078L46.1364 60.0063C46.4618 61.1861 45.7699 62.4064 44.5904 62.733C44.4731 62.766 44.3533 62.789 44.2319 62.8016Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.026 59.4364C53.882 59.5613 52.8325 58.7907 52.6097 57.6616L47.8532 33.6364C47.6116 32.4359 48.3889 31.2668 49.5896 31.0252C49.5955 31.0239 49.6013 31.0229 49.6072 31.0216C50.8086 30.7843 51.9748 31.5661 52.2122 32.7675L52.2122 32.7677L56.9686 56.7928C57.2058 57.9942 56.4242 59.1604 55.2228 59.3978L55.2226 59.3978L55.026 59.4364Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8199 56.0717C64.6021 56.1998 63.5108 55.3163 63.3827 54.0984L61.0635 32.0466C60.9354 30.8287 61.8189 29.7375 63.0368 29.6094C64.2547 29.4813 65.3459 30.3648 65.474 31.5827L67.7933 53.6347C67.9214 54.8526 67.0378 55.9436 65.8199 56.0717Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6139 52.7067L76.3669 52.7327C75.1423 52.7319 74.1503 51.7384 74.1511 50.5137C74.1511 50.5061 74.1512 50.4984 74.1512 50.4909L74.2691 30.4122C74.2846 29.1842 75.2824 28.1959 76.5105 28.1922C77.735 28.1988 78.7225 29.1967 78.716 30.4215L78.7161 30.4217L78.5982 50.5004C78.5988 51.6351 77.7426 52.5871 76.6139 52.7067Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4081 49.3417C86.1902 49.4694 85.0993 48.5856 84.9714 47.3677C84.9525 47.1881 84.9558 47.0067 84.9809 46.8279L87.5358 28.7225C87.6782 27.5063 88.7797 26.6357 89.996 26.778C91.2122 26.9204 92.0828 28.0219 91.9405 29.2381C91.9365 29.2722 91.9317 29.3061 91.9261 29.34L89.3712 47.4453C89.2297 48.4531 88.42 49.2351 87.4081 49.3417Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0119 74.8767L48.1116 80.23C40.7586 80.9862 33.8878 76.467 31.6703 69.4155L15.2692 16.7966L3.84638 17.9979C2.62849 18.126 1.53727 17.2425 1.40918 16.0246C1.28109 14.8067 2.16462 13.7155 3.38251 13.5874L16.6137 12.1958C17.6618 12.0854 18.6426 12.7278 18.9602 13.7326L35.9055 68.0915C37.4877 73.129 42.3952 76.3588 47.6477 75.8195L98.548 70.4662C99.7659 70.3381 100.857 71.2216 100.985 72.4395C101.113 73.6574 100.23 74.7486 99.0119 74.8767Z",
    fill: "#455A64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_3261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white",
    transform: "translate(0.945312 11.6133) rotate(-6.00392)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty_cart.5dd0e43c5c85a97ce136b9e387983147.svg";